import { useState } from 'react';

export type SortDir = 'asc' | 'desc';

/** Ordenação local de tabela: 1º clique = desc (métrica) ou asc (texto); 2º inverte. */
export function useTableSort() {
    const [sortKey, setSortKey] = useState<string | null>(null);
    const [sortDir, setSortDir] = useState<SortDir>('desc');

    const toggleSort = (key: string, textual = false) => {
        if (sortKey === key) {
            setSortDir((dir) => (dir === 'desc' ? 'asc' : 'desc'));
        } else {
            setSortKey(key);
            setSortDir(textual ? 'asc' : 'desc');
        }
    };

    return { sortKey, sortDir, toggleSort };
}

/** Compara valores com null sempre no fim (ex.: sends null pré-instrumentação). */
export function compareBy(a: unknown, b: unknown, dir: SortDir): number {
    const aNull = a == null;
    const bNull = b == null;
    if (aNull && bNull) return 0;
    if (aNull) return 1;
    if (bNull) return -1;
    let cmp: number;
    if (typeof a === 'string' || typeof b === 'string') {
        cmp = String(a).localeCompare(String(b), 'pt-BR', { sensitivity: 'base' });
    } else {
        cmp = (a as number) - (b as number);
    }
    return dir === 'asc' ? cmp : -cmp;
}
